import { fetchClinicsURL, insertOurUpdateClinicURL } from "../../apiEndPoints"
import { axiosPost } from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"
import {
    fetchClinicsFailure,
    fetchClinicsRequest,
    fetchClinicsSuccess,
} from "./clinicSlice"

export const fetchClinics = (
    user,
    orgId,
    success,
    failure,
    pageNo = 0,
    pageSize = 100,
    clinicName = ""
) => {
    let organisation =
        !orgId || orgId === undefined || orgId === ""
            ? user?.organizationListForUser?.[0]?.organizationId
            : orgId
    var dataSource = {
        source: "PORTAL",
        organizationId: organisation,
    }

    console.log(orgId, user, organisation, "sfjdslfjdsklfjdsklfjklsdfj")

    let url = fetchClinicsURL
    url += `?pageNo=${pageNo}&pageSize=${pageSize}`

    return dispatch => {
        dispatch(fetchClinicsRequest())
        console.log("fetch clinic url", fetchClinicsURL, dataSource)
        axiosPost(url, dataSource)
            .then(response => {
                const clinics = response.data.responseData || []
                success && success(clinics)
                dispatch(logTransaction("Fetch Clinics", response))
                dispatch(
                    fetchClinicsSuccess(
                        clinics.length > 0
                            ? clinics.filter(clinic => clinic.isActive)
                            : []
                    )
                )
            })
            .catch(err => {
                failure && failure([])
                dispatch(logTransaction("Fetch Clinics failure", err))
                dispatch(fetchClinicsFailure(err.message))
            })
    }
}

export const fetchClinic = (clinicId, success, failure) => {
    let url = fetchClinicsURL

    return dispatch => {
        axiosPost(url, {
            clinicId: clinicId,
        })
            .then(response => {
                const clinics = response.data.responseData || []
                success && success(clinics)
            })
            .catch(err => {
                failure && failure([])
            })
    }
}

export const fetchClinicsCount = (
    user,
    orgId,
    success,
    failure,
    clinicName = ""
) => {
    let organisation =
        !orgId || orgId === undefined || orgId === ""
            ? user?.organizationlistforuser?.[0]?.organizationId
            : orgId
    var dataSource = {
        source: "PORTAL",
        organizationId: organisation,
    }

    let url = fetchClinicsURL
    url += `?isCount=${true}&clinicName=${clinicName}`

    return dispatch => {
        console.log("fetch clinic url", fetchClinicsURL, dataSource)
        axiosPost(url, dataSource)
            .then(response => {
                const clinics = response.data.responseData || 0
                success && success(clinics)
                dispatch(logTransaction("Fetch Clinics count", response))
            })
            .catch(err => {
                failure && failure([])
                dispatch(logTransaction("Fetch Clinics failure count", err))
            })
    }
}

export const insertOrUpdateClinic = (data, success, failure) => {
    return function (dispatch, getState) {
        let url = insertOurUpdateClinicURL
        axiosPost(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD == 200) {
                    // let data = response.data.responseData;
                    success(response.data.responseData)
                } else {
                    failure(response.data?.statusMSG)
                }
            })
            .catch(err => {
                failure("Failed to update the clinic!")
            })
    }
}
